import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { C } from '../styles';

// ================================================================
// COMING SOON PAGE
// ================================================================
const ComingSoon = ({ title, icon, onBack }) => (
  <div style={S.container}>
    <div style={S.card}>
      <div style={{ textAlign: 'center', padding: '20px 0 28px' }}>
        <div style={{ fontSize: '56px', marginBottom: '16px' }}>{icon}</div>
        <h2 style={{ fontSize: '20px', fontWeight: '700', color: C.textPrimary, margin: '0 0 8px' }}>
          {title}
        </h2>
        <p style={{ fontSize: '13px', color: C.textMuted, margin: '0 0 24px', lineHeight: '1.6' }}>
          This portal is currently under development<br />and will be available soon.
        </p>
        <div style={{
          display: 'inline-block',
          background: C.accentDim,
          border: `1px solid ${C.accent}`,
          borderRadius: '20px',
          padding: '5px 16px',
          fontSize: '11px',
          fontWeight: '700',
          color: C.accent,
          letterSpacing: '1px',
          marginBottom: '28px',
        }}>
          COMING SOON
        </div>
        <div/>
        <button onClick={onBack} style={S.backBtn}>
          ← Back to Login
        </button>
      </div>
      <p style={S.footer}>Powered by VDSB</p>
    </div>
  </div>
);

// ================================================================
// LOGIN PAGE
// ================================================================
const Login = () => {
  const [username, setUsername]     = useState('');
  const [password, setPassword]     = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError]           = useState('');
  const [loading, setLoading]       = useState(false);
  const [portal, setPortal]         = useState('dashboard'); // 'dashboard' | 'hr' | 'customer'

  const { login } = useAuth();
  const navigate  = useNavigate();

  // Show Coming Soon for HR or Customer portal
  if (portal === 'hr') {
    return <ComingSoon title="HR Portal" icon="🏢" onBack={() => setPortal('dashboard')} />;
  }
  if (portal === 'customer') {
    return <ComingSoon title="Customer Portal" icon="👤" onBack={() => setPortal('dashboard')} />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(username, password, rememberMe);
      localStorage.removeItem('ccs_period');
      localStorage.removeItem('ccs_from');
      localStorage.removeItem('ccs_to');
      localStorage.removeItem('ccs_gran');
      localStorage.removeItem('ccs_branch');
      navigate('/');
    } catch (err) {
      const msg = err.response?.data?.error;
      setError(msg || 'Invalid username or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={S.container}>
      <div style={S.card}>

        {/* Logo */}
        <div style={S.logo}>
          <img src="/logo512.png" alt="CCS Logo" style={S.logoMark} />
          <h1 style={S.logoText}>CCS BI Dashboard</h1>
          <p style={S.logoSub}>Sign in to continue</p>
        </div>

        {/* Portal Switcher */}
        <div style={S.portalRow}>
          <button
            style={{ ...S.portalBtn, ...(portal === 'dashboard' ? S.portalBtnActive : {}) }}
            onClick={() => setPortal('dashboard')}
          >
            📊 Dashboard
          </button>
          <button
            style={{ ...S.portalBtn, ...(portal === 'hr' ? S.portalBtnActive : {}) }}
            onClick={() => setPortal('hr')}
          >
            🏢 HR Portal
          </button>
          <button
            style={{ ...S.portalBtn, ...(portal === 'customer' ? S.portalBtnActive : {}) }}
            onClick={() => setPortal('customer')}
          >
            👤 Customer
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={S.field}>
            <label style={S.label}>Username</label>
            <input
              style={S.input}
              type="text"
              value={username}
              onChange={e => setUsername(e.target.value)}
              placeholder="Enter username"
              autoComplete="username"
              required
            />
          </div>

          <div style={S.field}>
            <label style={S.label}>Password</label>
            <input
              style={S.input}
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Enter password"
              autoComplete={rememberMe ? 'current-password' : 'off'}
              required
            />
          </div>

          {/* Remember Me */}
          <div style={S.rememberRow}>
            <label style={S.rememberLabel}>
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={e => setRememberMe(e.target.checked)}
                style={{ marginRight: '7px', accentColor: C.accent, width: '14px', height: '14px' }}
              />
              Remember me
            </label>
          </div>

          {error && <p style={S.error}>{error}</p>}

          <button
            style={{ ...S.button, opacity: loading ? 0.7 : 1 }}
            type="submit"
            disabled={loading}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <p style={S.footer}>Powered by VDSB</p>
      </div>
    </div>
  );
};

const S = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: C.bgBase,
    padding: '20px',
  },
  card: {
    background: C.bgSurface,
    borderRadius: '20px',
    padding: '36px 32px',
    width: '100%',
    maxWidth: '380px',
    boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
    border: `1px solid ${C.border}`,
  },
  logo: {
    textAlign: 'center',
    marginBottom: '20px',
  },
  logoMark: {
    width: '64px',
    height: '64px',
    borderRadius: '50%',
    objectFit: 'contain',
    display: 'block',
    margin: '0 auto 12px',
  },
  logoText: {
    fontSize: '20px',
    fontWeight: '700',
    color: C.textPrimary,
    margin: '0 0 4px',
  },
  logoSub: {
    fontSize: '13px',
    color: C.textMuted,
    margin: 0,
  },
  // ── Portal switcher ──────────────────────────────────────
  portalRow: {
    display: 'flex',
    gap: '6px',
    marginBottom: '22px',
    background: C.bgElevated,
    borderRadius: '12px',
    padding: '4px',
    border: `1px solid ${C.border}`,
  },
  portalBtn: {
    flex: 1,
    padding: '7px 4px',
    background: 'transparent',
    border: 'none',
    borderRadius: '9px',
    fontSize: '11px',
    fontWeight: '600',
    color: C.textMuted,
    cursor: 'pointer',
    transition: 'all 0.15s',
    whiteSpace: 'nowrap',
  },
  portalBtnActive: {
    background: C.bgSurface,
    color: C.textPrimary,
    boxShadow: '0 1px 4px rgba(0,0,0,0.3)',
  },
  // ── Form fields ──────────────────────────────────────────
  field: {
    marginBottom: '16px',
  },
  label: {
    display: 'block',
    fontSize: '11px',
    fontWeight: '600',
    color: C.textMuted,
    marginBottom: '6px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  input: {
    width: '100%',
    padding: '11px 14px',
    background: C.bgElevated,
    border: `1px solid ${C.border}`,
    borderRadius: '10px',
    fontSize: '14px',
    color: C.textPrimary,
    outline: 'none',
    boxSizing: 'border-box',
  },
  rememberRow: {
    marginBottom: '20px',
    display: 'flex',
    alignItems: 'center',
  },
  rememberLabel: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '13px',
    color: C.textSec,
    cursor: 'pointer',
    userSelect: 'none',
  },
  error: {
    color: C.danger,
    fontSize: '13px',
    marginBottom: '14px',
    textAlign: 'center',
    padding: '8px',
    background: 'rgba(255,107,107,0.1)',
    borderRadius: '8px',
    border: `1px solid ${C.danger}`,
  },
  button: {
    width: '100%',
    padding: '13px',
    background: C.accent,
    color: '#000',
    border: 'none',
    borderRadius: '10px',
    fontSize: '14px',
    fontWeight: '700',
    cursor: 'pointer',
  },
  backBtn: {
    background: 'transparent',
    border: `1px solid ${C.border}`,
    borderRadius: '10px',
    padding: '10px 24px',
    fontSize: '13px',
    fontWeight: '600',
    color: C.textSec,
    cursor: 'pointer',
  },
  footer: {
    textAlign: 'center',
    fontSize: '11px',
    color: C.textMuted,
    marginTop: '20px',
    marginBottom: 0,
  },
};

export default Login;